import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import {
  joinCommunity,
  getMyMember,
} from '@wix/ambassador-members-v1-member/http';
import { Member, Set } from '@wix/ambassador-members-v1-member/types';

const createController: CreateControllerFn = async ({
  flowAPI,
  controllerConfig,
}) => {
  const { wixCodeApi, platformAPIs } = controllerConfig;
  const logger = flowAPI.panoramaClient.logger().error;

  const {
    errorHandler,
    translations: { t },
    httpClient,
  } = flowAPI;

  const { withErrorHandler, getResolvedError } = errorHandler;
  const makePublicAPI = async () => {
    try {
      const result = await withErrorHandler(
        () => httpClient.request(joinCommunity({})),
        {
          errorCodesMap: {
            statusCodeError: {
              UNAUTHENTICATED: () => ({
                message: t(
                  'app.widget.notifications_failedToJoinCommunity_UNAUTHENTICATED',
                ),
              }),
              PERMISSION_DENIED: () => ({
                message: t(
                  'app.widget.notifications_failedToJoinCommunity_PERMISSION_DENIED',
                ),
              }),
              FAILED_PRECONDITION: () => ({
                message: t(
                  'app.widget.notifications_failedToJoinCommunity_UNAUTHENTICATED',
                ),
              }),
            },
            applicationError: {
              COMMUNITY_JOIN_IMPOSSIBLE: () => ({
                message: t('app.widget.notifications_failedToJoinCommunity'),
              }),
            },
          },
        },
      );
      const member = result.data.member;
      controllerConfig.setProps({ membersError: null });
      return member;
    } catch (e) {
      const resolvedError = getResolvedError(e);
      logger(`An error occurred while making the profile public`, {
        originalError: e,
        resolvedError,
      });
      controllerConfig.setProps({ membersError: resolvedError.message });
      throw resolvedError;
    }
  };
  return {
    async pageReady(...args) {
      const isEditor =
        flowAPI?.environment?.isEditor || flowAPI?.environment?.isEditorX;
      const biToken = platformAPIs?.bi?.biToken;
      const navigateToPricingPlansApp = async (pricingPlansIds: any[]) => {
        const { relativeUrl }: any = await wixCodeApi?.site?.getSectionUrl({
          sectionId: 'membership_plan_picker_tpa',
          appDefinitionId: '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3',
        });
        wixCodeApi.location.to &&
          wixCodeApi?.location.to(
            relativeUrl +
              '?appSectionParams=' +
              JSON.stringify({ planIds: pricingPlansIds.join(',') }),
          );
      };
      const tempBaseUrl = controllerConfig.wixCodeApi.location.baseUrl;
      let baseUrl;
      const isEditor_X =
        controllerConfig?.config?.style?.styleParams?.booleans?.responsive ??
        false;
      if (tempBaseUrl.includes('editor.wix')) {
        baseUrl = '';
      } else if (tempBaseUrl.includes('editorx')) {
        baseUrl = '';
      } else if (tempBaseUrl.includes('wixsite.com/')) {
        baseUrl = tempBaseUrl.substring(0, tempBaseUrl.indexOf('wixsite.com/'));
        baseUrl = baseUrl + 'wixsite.com/';
      } else {
        baseUrl = controllerConfig.wixCodeApi.location.baseUrl;
      }
      const instance = controllerConfig.appParams.instance;
      const { appParams, compId } = controllerConfig;
      const user: any = {};

      const requestLogin = wixCodeApi?.user.promptLogin;
      let member: Member | undefined;
      try {
        const getMyMemberResult = await withErrorHandler(
          () => httpClient.request(getMyMember({ fieldsets: [Set.EXTENDED] })),
          {
            errorCodesMap: {
              statusCodeError: {
                PERMISSION_DENIED: () => ({
                  message: t(
                    'app.widget.notifications_failedToGetMember_PERMISSION_DENIED',
                  ),
                }),
                UNAUTHENTICATED: () => ({
                  message: t(
                    'app.widget.notifications_failedToGetMember_UNAUTHENTICATED',
                  ),
                }),
              },
            },
          },
        );
        member = getMyMemberResult.data.member;
      } catch (e) {
        const resolvedError = getResolvedError(e);
        logger(`An error occurred while getting the member`, {
          originalError: e,
          resolvedError,
        });
      }

      if (args[1]?.user?.currentUser.loggedIn) {
        try {
          user.instance = args[1]?.user?.currentUser?.instance;
        } catch (error) {
          console.error(error);
        }
      }
      user.id = args[1]?.user?.currentUser?.id;
      user.isLoggedIn = args[1]?.user?.currentUser?.loggedIn;
      user.role = args[1]?.user?.currentUser?.role;
      user.privacyStatus = member?.privacyStatus || '';
      user.makePublic = makePublicAPI;
      wixCodeApi?.user?.onLogin((userData: any) => {
        setTimeout(async () => {
          const signedInstance =
            wixCodeApi?.site?.getAppToken &&
            wixCodeApi?.site?.getAppToken(
              controllerConfig.appParams.appDefinitionId,
            );
          const loggedInUser: any = {};
          loggedInUser.id = userData?.id;
          loggedInUser.isLoggedIn = userData?.loggedIn;
          loggedInUser.role = userData?.role;
          controllerConfig.setProps({
            appParams,
            compId,
            user: loggedInUser,
            instance: signedInstance,
            biToken,
            fitToContentHeight: true,
            isEditor,
          });
        });
      });
      controllerConfig.setProps({
        isEditor_X,
        user,
        baseUrl,
        instance,
        requestLogin,
        navigateToPricingPlansApp,
        appParams,
        compId,
        biToken,
        fitToContentHeight: true,
        isEditor,
      });
    },
  };
};

export default createController;
